import { render, staticRenderFns } from "./EditGDoc.vue?vue&type=template&id=20865a35&scoped=true"
import script from "./EditGDoc.vue?vue&type=script&lang=js"
export * from "./EditGDoc.vue?vue&type=script&lang=js"
import style0 from "./EditGDoc.vue?vue&type=style&index=0&id=20865a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20865a35",
  null
  
)

export default component.exports